import utils from '../../utils';
export default {
    name: 'markets-ui-mixin',
    props: {
        namespaced: {
            type: Boolean,
            default: false
        },
        skin: {
            type: String,
            default: 'white'
        }
    },
    computed: {
        skinStyle() {
            return utils.mdsNS(
                `container--${utils.getSkinSuffix(this.skin)}`,
                this.namespaced
            );
        }
    },
    methods: {
        mdsNS(context) {
            return utils.mdsNS(context, this.namespaced);
        }
    }
};
